import React, { useLayoutEffect } from 'react'

import { Button, Icon, InputUI, List, Loader, Loading, Subsection } from '@fourthwall/components'
import { PlusIcon } from '@fourthwall/icons'

import { SelectedItem } from './components/SelectedItem'
import * as S from './styled'
import type { SelectedItemsProps } from './types'

export const SelectedItems = ({
  header,
  disabled,
  isLoading,
  itemsCount,
  withHeader = true,
  data,
  error,
  maxHeight,
  addItemsButtonLabel = 'Add',
  addItemsButtonIcon,
  renderItem,
  onAddItems,
  onRemoveItem,
}: SelectedItemsProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const [currentHeight, setCurrentHeight] = React.useState<number>(0)

  useLayoutEffect(() => {
    if (!isLoading && containerRef.current) {
      setCurrentHeight(containerRef.current.clientHeight)
    }
  }, [isLoading, itemsCount])

  return (
    <S.Container disabled={disabled}>
      <Subsection>
        {withHeader && (
          <S.Header>
            <S.HeaderContentWrapper>
              <S.HeaderContent>{header}</S.HeaderContent>
            </S.HeaderContentWrapper>
            {!disabled && onAddItems && (
              <Button
                label={addItemsButtonLabel}
                size="small"
                leftIcon={addItemsButtonIcon || <Icon component={PlusIcon} height={12} />}
                onClick={() => onAddItems()}
              />
            )}
          </S.Header>
        )}
        <div ref={containerRef}>
          <S.SelectedItemsList maxHeight={maxHeight}>
            {!!itemsCount &&
              (!data?.length ? (
                <S.LoaderContainer height={currentHeight || undefined}>
                  <Loader />
                </S.LoaderContainer>
              ) : (
                <Loading isLoading={isLoading}>
                  <List
                    data={data || []}
                    topBorder={!withHeader}
                    renderItem={(item, index) => (
                      <SelectedItem
                        withMaxHeight={!!maxHeight}
                        disabled={disabled}
                        onRemove={() => onRemoveItem(item)}
                      >
                        {renderItem(item, index)}
                      </SelectedItem>
                    )}
                  />
                </Loading>
              ))}
          </S.SelectedItemsList>
        </div>
      </Subsection>
      {!!error?.length && <InputUI.Error>{error}</InputUI.Error>}
    </S.Container>
  )
}
